import axios from "@/libs/request";

// 任务上报
export const taskReport = (data) => axios.request({ url: "/ks/task/report", data, unHint: true });

// 获取当前天
export const getRealDayApi = (data) => axios.request({ url: "/ks/task/day", data, unHint: true });

// 任务确认接口
export const taskConfirm = (data) => axios.request({ url: "/ks/task/confirm", data, unHint: true });
